var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { useLang } from '../hooks/use-lang';
var cls = classNames('onboarding-header');
export var OnboardingHeaderDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", ";\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: ", ";\n  "], ["\n    font-size: ", ";\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: ", ";\n  "])), theme.FONT_SIZE(16), theme.UNIT(4))
});
var PretitleStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin: 0;\n    font-weight: 300;\n    text-align: center;\n    font-size: 1em;\n  "], ["\n    margin: 0;\n    font-weight: 300;\n    text-align: center;\n    font-size: 1em;\n  "])))
});
var TitleStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin: 0;\n    font-weight: 300;\n    text-align: center;\n    font-family: ", ";\n    font-size: ", "em;\n\n    b {\n      color: ", ";\n    }\n  "], ["\n    margin: 0;\n    font-weight: 300;\n    text-align: center;\n    font-family: ", ";\n    font-size: ", "em;\n\n    b {\n      color: ", ";\n    }\n  "])), theme.FONT('serif'), 32 / 16, theme.COLOR('primary'))
});
// -------- Components -------->
var My = {
  NAME: 'OnboardingHeader',
  Container: styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Pretitle: styled.h3(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), PretitleStyles),
  Title: styled.h1(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles)
};
export var OnboardingHeader = function (props) {
  var componentProps = useComponentProps(My.NAME, OnboardingHeaderDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    pretitle = componentProps.pretitle,
    title = componentProps.title;
  if (!title && !pretitle) {
    return null;
  }
  var t = useLang();
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, pretitle && React.createElement(My.Pretitle, {
    dangerouslySetInnerHTML: {
      __html: t(pretitle)
    }
  }), title && React.createElement(My.Title, {
    dangerouslySetInnerHTML: {
      __html: t(title)
    }
  }), children);
};
OnboardingHeader.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;